<template>
  <!--
    	作者：gmshop
    	时间：2019-10-25
    	描述：组件-选择用户
    -->
  <el-dialog title="业绩明细" :visible.sync="dialogVisible" @close="cancelFunc" :close-on-click-modal="false" :close-on-press-escape="false" width="800px" append-to-body>
    <div class="common-seach-wrap">
      <div>【{{ log.grade.name }}】业绩明细</div>
      <div>{{ log.user.nickName }}【ID:{{  log.user_id}}】 {{ log.user.mobile }} | 总业绩：{{ log.total_performance }}</div>
    </div>

    <!--内容-->
    <div class="product-content">
      
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column prop="order.order_no" label="订单号"></el-table-column>
          <el-table-column prop="" label="下单用户">
            <template slot-scope="scope">
              <p v-if="scope.row.order.user">
                <span>{{scope.row.order.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.order.user.user_id}})</span>
              </p>
              <p v-if="scope.row.order.user">{{scope.row.order.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="product.product_name" label="商品"></el-table-column>
          <el-table-column prop="performance" label="业绩金额"></el-table-column>
          <el-table-column prop="create_time" label="产生时间">
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*搜索表单对象*/
      formInline: {
      },
      /*会员列表*/
      tableData: [],
      /*性别列表*/
      /*选中的*/
      multipleSelection: [],
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['is_open', 'log'],
  created() {
    this.getTableList();
    this.dialogVisible = this.is_open;
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取数据*/
    getTableList() {
      let self = this;
      self.loading = true;
      let params = self.formInline;
      params.grade_id = self.log.grade_id;
      params.profits_id = self.log.id;
      params.user_id = self.log.user_id;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      UserApi.getPfofitsLog(params,true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.grade;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*查询*/
    search() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },

    /*关闭弹窗*/
    cancelFunc(e) {
      this.emitFunc();
    },

    /*发送事件*/
    emitFunc(e) {
      this.dialogVisible = false;
      if (e && typeof e != 'undefined') {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/ProfitsLog.vue